import React, { useCallback, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import DatePicker from "../_components/datePicker";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import TableText from "./../../../component/atoms/text/table/tableText";
import Modal from "../../../component/templates/Modal";
import { formatNumberWithCommas } from "./../../../util/formatNumber";
import SelectBox from "../../../component/organisms/selectBox";
import SearchBar from "../../../component/atoms/input/searchBar";
import PeriodChart from "./_components/periodChart";
import ProductChart from "./_components/productChart";
import moment from "moment";
import EnvironmentChart from "./_components/environmentChart";
import AnalyticsApi from "../../../api/analytics.api";
import getToday from "../../../util/getToday";
import { errorHandler } from "../../../util/errorHandler";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { route } from "../../../router/route";

const StatisticsSales = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const today = useMemo(() => getToday(), []);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (tab.product) {
      getProductData();
    }
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 탭 관련 ---------- //
  const [tab, setTab] = useState({
    period: true,
    product: false,
    environment: false,
  });

  useEffect(() => {
    setPopupIsOpen(false);
    setDateType("day"); // 날짜 타입 초기화
    setSelectedDate(""); // 날짜 초기화
    setSelectedSort("상품별"); // 상품별 초기화
    setSelectedEnvSort("기기별"); // 환경별 초기화
    setSelectedStartDate(""); // 시작 날짜 초기화
    setSelectedEndDate(""); // 끝 날짜 초기화
    setKeyword(""); // 검색어 초기화
    setPeriodData([]); // 기간 데이터 초기화
    setPeriodTableObj(initialPeriodTableObj); // 기간 테이블 초기화
    setProductDataList([]); // 상품 데이터 초기화
    setCategoryDataList([]); // 카테고리 데이터 초기화
    setProductTableObj(initialProductTableObj); // 상품 테이블 초기화
    setDeviceDataList([]); // 기기 데이터 초기화
    setDeviceDataObj(initialDeviceTableObj); // 기기 테이블 초기화
    setMethodDataList([]); // 결제수단 데이터 초기화
    setMethodDataObj(initialMethodTableObj); // 결제수단 테이블 초기화
  }, [tab]); // eslint-disable-line react-hooks/exhaustive-deps

  // 일간, 주간, 월간
  const [dateType, setDateType] = useState("day");

  const [selectedDate, setSelectedDate] = useState("");
  const [weekStartDate, setWeekStartDate] = useState("");
  const [weekEndDate, setWeekEndDate] = useState("");

  // 날짜 타입이 변경되면 상태값 초기화
  useEffect(() => {
    setSelectedDate("");
    setPeriodData([]);
    setPeriodTableObj(initialPeriodTableObj);
  }, [dateType]); // eslint-disable-line react-hooks/exhaustive-deps

  const reducer = useCallback((data, key) => {
    return data.reduce((acc, cur) => {
      return acc + Number(cur[key]);
    }, 0);
  }, []);

  // ---------- 기간별 관련 ---------- //
  const [periodData, setPeriodData] = useState([]);
  const initialPeriodTableObj = {
    totalRevenue: 0, // 매출 합계 & 테이블 - 매출
    totalSalesCount: 0, // 구매 합계 & 테이블 - 구매건수
    totalTotalPay: 0, // 테이블 - 상품금액
    totalDiscount: 0, // 테이블 - 할인금액
    totalRealPay: 0, // 테이블 - 결제금액
    totalRefund: 0, // 테이블 - 환불금액
  };
  const [periodTableObj, setPeriodTableObj] = useState(initialPeriodTableObj);

  const getPeriodData = async (size, searchDate, searchType, startDate) => {
    const processedSearchDate = moment(searchDate).format("YYYY-MM-DD");

    let processedStartDate = "";
    if (startDate) {
      processedStartDate = moment(startDate).format("YYYY-MM-DD");
    }

    try {
      const data = {
        page: 1,
        size,
        periodType: dateType,
        searchDate: processedSearchDate,
        searchType,
      };

      if (startDate) {
        data.startDate = processedStartDate;
      }

      const response = (await AnalyticsApi.getListOrder(data)).data.data
        .content;

      // response에서 orderdate를 moment 돌려서 YYYY-MM-DD 형식으로 변환
      const processedResponse = response.map((item) => {
        return {
          ...item,
          date: moment(item.orderdate).format("YYYY-MM-DD"),
          couponpay: Number(item.couponpay),
          pointpay: Number(item.pointpay),
          realpay: Number(item.realpay),
          refundamount: Number(item.refundamount),
          salescount: Number(item.salescount),
          totalpay: Number(item.totalpay),
        };
      });

      setPeriodData(processedResponse);

      let obj = {};
      if (dateType !== "month") {
        obj = {
          totalRevenue:
            reducer(processedResponse, "realpay") -
            reducer(processedResponse, "refundamount"),
          totalSalesCount: reducer(processedResponse, "salescount"),
          totalTotalPay: reducer(processedResponse, "totalpay"),
          totalDiscount: processedResponse.reduce((acc, cur) => {
            return acc + Number(cur.couponpay) + Number(cur.pointpay);
          }, 0),
          totalRealPay: reducer(processedResponse, "realpay"),
          totalRefund: reducer(processedResponse, "refundamount"),
        };
      } else {
        const lastData = processedResponse[processedResponse.length - 1];
        obj = {
          totalRevenue: lastData.realpay - lastData.refundamount,
          totalSalesCount: lastData.salescount,
          totalTotalPay: lastData.totalpay,
          totalDiscount: lastData.couponpay + lastData.pointpay,
          totalRealPay: lastData.realpay,
          totalRefund: lastData.refundamount,
        };
      }
      setPeriodTableObj(obj);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (selectedDate && dateType === "day") {
      getPeriodData(1, selectedDate, "period");
    } else if (selectedDate && dateType === "week") {
      // ex) "2024-12-16 (월) → 2024-12-22 (일)"
      const [startPart, endPart] = selectedDate
        .split("→")
        .map((part) => part.trim());

      const startDate = startPart.split(" ")[0]; // ex) "2024-12-16"
      setWeekStartDate(startDate);
      const endDate = endPart.split(" ")[0]; // ex) "2024-12-22"
      setWeekEndDate(endDate);

      getPeriodData(7, endDate, "period", startDate);
    } else if (selectedDate && dateType === "month") {
      // selectedDate가 "2024-12" 이렇게 오면 해당하는 달의 1일을 추출
      const firstDayOfMonth = moment(selectedDate).startOf("month").format();
      getPeriodData(1, firstDayOfMonth, "period");
    }
  }, [selectedDate]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 상품별 관련 ---------- //
  // 날짜 선택 관련
  const [popupIsOpen, setPopupIsOpen] = useState(false);

  const [selectedStartDate, setSelectedStartDate] = useState("");

  const [selectedEndDate, setSelectedEndDate] = useState("");

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");

  useEffect(() => {
    if (selectedStartDate === "" && selectedEndDate !== "") {
      setModalIsOpen(true);
      setModalTitle("날짜 선택 오류");
      setModalText("시작 날짜를 선택해주세요.");
      setSelectedStartDate("");
      setSelectedEndDate("");
    }

    if (selectedEndDate !== "" && selectedStartDate > selectedEndDate) {
      setModalIsOpen(true);
      setModalTitle("날짜 선택 오류");
      setModalText("끝 날짜가 시작 날짜보다 빠를 수 없습니다.");
      setSelectedEndDate("");
    }
  }, [selectedStartDate, selectedEndDate]);

  // 필터링
  const [selectedSort, setSelectedSort] = useState("상품별");

  const [sortListBoxOpen, setSortListBoxOpen] = useState(false);

  const sortList = [
    {
      title: "상품별",
      value: "상품별",
    },
    {
      title: "카테고리별",
      value: "카테고리별",
    },
  ];

  // 상품 검색
  const [keyword, setKeyword] = useState("");

  // 데이터 가져오기
  const [productDataList, setProductDataList] = useState([]);
  const [categoryDataList, setCategoryDataList] = useState([]);

  const initialProductTableObj = {
    totalRealRevenue: 0, // 순 판매금액 합계 & 테이블 - 순 판매금액
    totalSalesCount: 0, // 판매 개수 합계 & 테이블 - 판매개수
    totalAvgPrice: 0, // 테이블 - 평균 상품 금액
    totalCancelCount: 0, // 테이블 - 취소개수
    totalCancelRate: 0, // 테이블 - 취소율
    totalRevenue: 0, // 테이블 - 판매금액
    totalCancelRevenue: 0, // 테이블 - 취소금액
  };

  const [productTableObj, setProductTableObj] = useState(
    initialProductTableObj
  );

  const getProductData = async () => {
    try {
      const data = {
        page: 1,
        searchType: selectedSort === "상품별" ? "merch" : "category",
      };

      if (selectedEndDate) {
        data.searchDate = moment(selectedEndDate).format("YYYY-MM-DD");
      } else {
        data.searchDate = today;
      }

      if (selectedStartDate) {
        data.startDate = moment(selectedStartDate).format("YYYY-MM-DD");
      } else {
        data.startDate = today;
      }

      if (searchParams.get("keyword")) {
        data.keyword = searchParams.get("keyword");
      }

      const response = (await AnalyticsApi.getListOrder(data)).data.data
        .content;

      const processedResponse = response.map((item) => {
        return {
          ...item,
          couponpay: Number(item.couponpay),
          pointpay: Number(item.pointpay),
          realpay: Number(item.realpay),
          refundamount: Number(item.refundamount),
          refundcount: Number(item?.refundcount || 0),
          salescount: Number(item.salescount),
          totalpay: Number(item.totalpay),
        };
      });

      if (selectedSort === "상품별") {
        setProductDataList(processedResponse);
      } else {
        setCategoryDataList(processedResponse);
      }

      const obj = {
        totalRealRevenue:
          reducer(processedResponse, "realpay") -
          reducer(processedResponse, "refundamount"),
        totalSalesCount: reducer(processedResponse, "salescount"),
        totalAvgPrice:
          reducer(processedResponse, "realpay") /
          reducer(processedResponse, "salescount"),
        totalCancelCount: reducer(processedResponse, "refundcount"),
        totalCancelRate: (
          (reducer(processedResponse, "refundcount") /
            reducer(processedResponse, "salescount")) *
          100
        ).toFixed(1),
        totalRevenue: reducer(processedResponse, "realpay"),
        totalCancelRevenue: reducer(processedResponse, "refundamount"),
      };

      setProductTableObj(obj);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (tab.product) {
      getProductData();
    }
  }, [selectedSort]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 환경별 관련 ---------- //
  // 필터링
  const [selectedEnvSort, setSelectedEnvSort] = useState("기기별");

  const [envSortListBoxOpen, setEnvSortListBoxOpen] = useState(false);

  const envSortList = [
    {
      title: "기기별",
      value: "기기별",
    },
    {
      title: "결제수단별",
      value: "결제수단별",
    },
  ];

  // 데이터 가져오기
  const [deviceDataList, setDeviceDataList] = useState([]);
  const initialDeviceTableObj = {
    pc: {},
    mo: {},
  };
  const [deviceDataObj, setDeviceDataObj] = useState(initialDeviceTableObj);
  const [methodDataList, setMethodDataList] = useState([]);
  const initialMethodTableObj = {
    creditCard: {},
    naverPay: {},
    kakaoPay: {},
    tossPay: {},
  };
  const [methodDataObj, setMethodDataObj] = useState(initialMethodTableObj);

  const getEnvironmentData = async () => {
    try {
      let data = {};

      data = {
        page: 1,
        searchType: "env",
      };

      if (selectedEndDate) {
        data.searchDate = moment(selectedEndDate).format("YYYY-MM-DD");
      } else {
        data.searchDate = today;
      }

      if (selectedStartDate) {
        data.startDate = moment(selectedStartDate).format("YYYY-MM-DD");
      } else {
        data.startDate = today;
      }

      const stringToNumber = (data) => {
        return data.map((item) => {
          return {
            ...item,
            couponpay: Number(item.couponpay),
            pointpay: Number(item.pointpay),
            realpay: Number(item.realpay),
            refundamount: Number(item.refundamount),
            salescount: Number(item.salescount),
            totalpay: Number(item.totalpay),
          };
        });
      };

      const deviceResponse = (await AnalyticsApi.getListOrder(data)).data.data
        .content;

      const processedDeviceResponse = stringToNumber(deviceResponse);

      setDeviceDataList(processedDeviceResponse);

      const sumDeviceAmount = reducer(processedDeviceResponse, "realpay");

      // processedDeviceResponse에 각 아이템의 realpay를 sumAmount로 나눈 비율을 percent라는 key 추가하여 deviceDataObj에 저장
      processedDeviceResponse.forEach((item) => {
        item.percent = ((item.realpay / sumDeviceAmount) * 100).toFixed(1);
      });

      // paymethod, percent, realpay만 있는 객체로 변환
      const filteredDevice = processedDeviceResponse.map((item) => {
        return {
          payenv: item.payenv,
          percent: item.percent,
          realpay: item.realpay,
        };
      });

      const deviceObj = {
        pc: filteredDevice.find((item) => item.payenv === "PC"),
        mo: filteredDevice.find((item) => item.payenv === "MO"),
      };

      setDeviceDataObj(deviceObj);

      data = {
        ...data,
        searchType: "method",
      };

      const methodResponse = (await AnalyticsApi.getListOrder(data)).data.data
        .content;

      const filteredMethodResponse = methodResponse.filter((item) => {
        return (
          item.paymethod === "신용카드" ||
          item.paymethod === "네이버페이" ||
          item.paymethod === "카카오페이" ||
          item.paymethod === "토스페이"
        );
      });

      const processedMethodResponse = stringToNumber(filteredMethodResponse);

      const sumMethodAmount = reducer(processedMethodResponse, "realpay");

      setMethodDataList(processedMethodResponse);

      // processedMethodResponse에 각 아이템의 realpay를 sumAmount로 나눈 비율을 percent라는 key 추가하여 methodDataObj에 저장
      processedMethodResponse.forEach((item) => {
        item.percent = ((item.realpay / sumMethodAmount) * 100).toFixed(1);
      });

      // paymethod, percent, realpay만 있는 객체로 변환
      const filteredMethod = processedMethodResponse.map((item) => {
        return {
          paymethod: item.paymethod,
          percent: item.percent,
          realpay: item.realpay,
        };
      });

      const methodObj = {
        creditCard: filteredMethod.find(
          (item) => item.paymethod === "신용카드"
        ),
        naverPay: filteredMethod.find(
          (item) => item.paymethod === "네이버페이"
        ),
        kakaoPay: filteredMethod.find(
          (item) => item.paymethod === "카카오페이"
        ),
        tossPay: filteredMethod.find((item) => item.paymethod === "토스페이"),
      };

      setMethodDataObj(methodObj);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (tab.environment) {
      getEnvironmentData();
    }
  }, [selectedEnvSort]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>매출</TableTitle>
          <TabWrapper>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <Tab
                isActive={tab.period}
                onClick={() => {
                  setTab({
                    period: true,
                    product: false,
                    environment: false,
                  });
                }}
              >
                <TabText isActive={tab.period}>기간별</TabText>
              </Tab>
              <Tab
                isActive={tab.product}
                onClick={() => {
                  setTab({
                    user: false,
                    product: true,
                    environment: false,
                  });
                }}
              >
                <TabText isActive={tab.product}>상품별</TabText>
              </Tab>
              <Tab
                isActive={tab.environment}
                onClick={() => {
                  setTab({
                    period: false,
                    product: false,
                    environment: true,
                  });
                }}
              >
                <TabText isActive={tab.environment}>환경별</TabText>
              </Tab>
            </div>
            {!tab.period && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <DatePicker
                  wrapperStyle={{
                    width: "fit-content",
                  }}
                  popupIsOpen={popupIsOpen}
                  onClick={() => {
                    setPopupIsOpen(!popupIsOpen);
                  }}
                  startDate={selectedStartDate}
                  startDateHandler={(date) => {
                    setSelectedStartDate(date);
                  }}
                  endDate={selectedEndDate}
                  endDateHandler={(date) => {
                    setSelectedEndDate(date);
                  }}
                  footerBtnHandler={() => {
                    if (tab.product) {
                      getProductData();
                    } else if (tab.environment) {
                      getEnvironmentData();
                    }

                    setPopupIsOpen(false);
                  }}
                  isPopupRight={true}
                />
                {/* <ExcelBtn /> */}
              </div>
            )}
          </TabWrapper>

          <TabContentContainer>
            {/* ********** 기간별 ********** */}
            {tab.period && (
              <>
                <TabContentHeader>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 20,
                    }}
                  >
                    <DateTypeBtnWrapper>
                      <DateTypeBtn
                        isActive={dateType === "day"}
                        onClick={() => {
                          setDateType("day");
                        }}
                      >
                        일간
                      </DateTypeBtn>
                      <DateTypeBtn
                        isActive={dateType === "week"}
                        onClick={() => {
                          setDateType("week");
                        }}
                      >
                        주간
                      </DateTypeBtn>
                      <DateTypeBtn
                        isActive={dateType === "month"}
                        onClick={() => {
                          setDateType("month");
                        }}
                      >
                        월간
                      </DateTypeBtn>
                    </DateTypeBtnWrapper>
                    <DatePicker
                      dateType={dateType === "day" ? "date" : dateType}
                      isOnlyOneDate={true}
                      onClick={() => {}}
                      date={selectedDate}
                      dateHandler={setSelectedDate}
                    />
                  </div>
                  {/* <ExcelBtn /> */}
                </TabContentHeader>
                {/* 매출 - 요약 */}
                <ChartContainer
                  style={{
                    height: "fit-content",
                    minHeight: 107,
                  }}
                >
                  <ChartHeader>
                    <ChartHeaderText>요약</ChartHeaderText>
                  </ChartHeader>

                  <div
                    style={{
                      width: "100%",
                      height: 107,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* 매출 - 요약 - 매출 합계 */}
                    <div
                      style={{
                        width: 544,
                        borderRight: "0.5px solid rgba(255, 255, 255, 0.12)",
                        height: "100%",
                        padding: "20px 30px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          lineHeight: "22.75px",
                          color: "#aaa",
                        }}
                      >
                        매출 합계
                      </PretendardText>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          gap: 6,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 700,
                            fontSize: "30px",
                            lineHeight: "41.5px",
                            color: "#f3f3f3",
                          }}
                        >
                          {formatNumberWithCommas(periodTableObj.totalRevenue)}
                        </PretendardText>
                        <PretendardText
                          style={{
                            fontWeight: 700,
                            fontSize: "16px",
                            lineHeight: "28px",
                            letterSpacing: "-0.3%",
                            color: "#f3f3f3",
                          }}
                        >
                          원
                        </PretendardText>
                      </div>
                    </div>
                    {/* 매출 - 요약 - 구매 합계 */}
                    <div
                      style={{
                        width: 544,
                        height: "100%",
                        padding: "20px 30px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          lineHeight: "22.75px",
                          color: "#aaa",
                        }}
                      >
                        구매 합계
                      </PretendardText>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          gap: 6,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 700,
                            fontSize: "30px",
                            lineHeight: "41.5px",
                            color: "#f3f3f3",
                          }}
                        >
                          {formatNumberWithCommas(
                            periodTableObj.totalSalesCount
                          )}
                        </PretendardText>
                        <PretendardText
                          style={{
                            fontWeight: 700,
                            fontSize: "16px",
                            lineHeight: "28px",
                            letterSpacing: "-0.3%",
                            color: "#f3f3f3",
                          }}
                        >
                          건
                        </PretendardText>
                      </div>
                    </div>
                  </div>
                </ChartContainer>

                {/* 매출 - 차트 데이터 */}
                <ChartContainer>
                  <ChartHeader>
                    <ChartHeaderText>차트 데이터</ChartHeaderText>
                  </ChartHeader>
                  <ChartGraphWrapper>
                    <div
                      style={{
                        width: "fit-content",
                        height: 23,
                        display: "flex",
                        alignItems: "center",
                        gap: 20,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            backgroundColor: "#b658ff",
                            borderRadius: "50%",
                          }}
                        />
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "22.75px",
                          }}
                        >
                          매출 금액
                        </PretendardText>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            backgroundColor: "#34f3ff",
                            borderRadius: "50%",
                          }}
                        />
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "22.75px",
                          }}
                        >
                          구매 건수
                        </PretendardText>
                      </div>
                    </div>
                  </ChartGraphWrapper>

                  {/* 애니메이션 초기화를 위해 조건부 렌더링으로 진행 (dataList 조건으로 다르게 데이터는 방법은 애니메이션 초기화 안 됨) */}
                  {/* 차트 영역 */}
                  <PeriodChart dataList={periodData} dateType={dateType} />

                  <ChartHeaderText
                    style={{
                      alignSelf: "flex-start",
                      margin: "0px 0px 12px 60px",
                    }}
                  >
                    {dateType === "day" &&
                      (periodData.length > 0
                        ? moment(periodData[0]?.orderdate).format(
                            "YYYY-MM-DD (ddd)"
                          )
                        : "데이터 없음")}
                    {dateType === "week" && (
                      <>
                        {weekStartDate ? (
                          <>
                            {moment(weekStartDate).format("YYYY-MM-DD (ddd)")} →{" "}
                            {moment(weekEndDate).format("YYYY-MM-DD (ddd)")}
                          </>
                        ) : (
                          "데이터 없음"
                        )}
                      </>
                    )}
                    {dateType === "month" && (
                      <>
                        {selectedDate ? (
                          <>{moment(selectedDate).format("YYYY년 MM월")}</>
                        ) : (
                          "데이터 없음"
                        )}
                      </>
                    )}
                  </ChartHeaderText>
                  {/* 테이블 영역 */}
                  <table
                    style={{
                      width: "924px",
                      borderSpacing: 0,
                      borderCollapse: "collapse",
                      marginBottom: 40,
                    }}
                  >
                    <colgroup>
                      {/* 합계: 924px */}
                      {/* 매출 */}
                      <col width="130px" />
                      {/* 구매 건수 */}
                      <col width="169px" />
                      {/* 상품금액 */}
                      <col width="156px" />
                      {/* 할인금액 */}
                      <col width="141px" />
                      {/* 결제금액 */}
                      <col width="158px" />
                      {/* 환불금액 */}
                      <col width="170px" />
                    </colgroup>
                    <thead>
                      <tr
                        style={{
                          height: 41,
                          backgroundColor: "#313233",
                          borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                        }}
                      >
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            매출
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            구매 건수
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            상품금액
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            할인금액
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            결제금액
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                              paddingRight: 35,
                            }}
                          >
                            환불금액
                          </TableText>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        style={{
                          height: 40,
                          borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                        }}
                      >
                        {/* 매출 */}
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(
                              periodTableObj.totalRevenue
                            )}
                            원
                          </TableText>
                        </td>
                        {/* 구매 건수 */}
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(
                              periodTableObj.totalSalesCount
                            )}
                            건
                          </TableText>
                        </td>
                        {/* 상품금액 */}
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(
                              periodTableObj.totalTotalPay
                            )}
                            원
                          </TableText>
                        </td>
                        {/* 할인금액 */}
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(
                              periodTableObj.totalDiscount
                            )}
                            원
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(
                              periodTableObj.totalRealPay
                            )}
                            원
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                              paddingRight: 35,
                            }}
                          >
                            {formatNumberWithCommas(periodTableObj.totalRefund)}
                            원
                          </TableText>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ChartContainer>
              </>
            )}

            {/* ********** 상품별 ********** */}
            {tab.product && (
              <>
                {/* 상품별 - 요약 */}
                <ChartContainer
                  style={{
                    height: "fit-content",
                    minHeight: 107,
                  }}
                >
                  <ChartHeader>
                    <ChartHeaderText>요약</ChartHeaderText>
                  </ChartHeader>

                  <div
                    style={{
                      width: "100%",
                      height: 107,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* 상품별 - 요약 - 순 판매금액 합계 */}
                    <div
                      style={{
                        width: 544,
                        borderRight: "0.5px solid rgba(255, 255, 255, 0.12)",
                        height: "100%",
                        padding: "20px 30px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          lineHeight: "22.75px",
                          color: "#aaa",
                        }}
                      >
                        순 판매금액 합계
                      </PretendardText>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          gap: 6,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 700,
                            fontSize: "30px",
                            lineHeight: "41.5px",
                            color: "#f3f3f3",
                          }}
                        >
                          {formatNumberWithCommas(
                            productTableObj.totalRealRevenue
                          )}
                        </PretendardText>
                        <PretendardText
                          style={{
                            fontWeight: 700,
                            fontSize: "16px",
                            lineHeight: "28px",
                            letterSpacing: "-0.3%",
                            color: "#f3f3f3",
                          }}
                        >
                          원
                        </PretendardText>
                      </div>
                    </div>
                    {/* 매출 - 요약 - 판매 개수 합계 */}
                    <div
                      style={{
                        width: 544,
                        height: "100%",
                        padding: "20px 30px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          lineHeight: "22.75px",
                          color: "#aaa",
                        }}
                      >
                        판매 개수 합계
                      </PretendardText>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          gap: 6,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 700,
                            fontSize: "30px",
                            lineHeight: "41.5px",
                            color: "#f3f3f3",
                          }}
                        >
                          {formatNumberWithCommas(
                            productTableObj.totalSalesCount
                          )}
                        </PretendardText>
                        <PretendardText
                          style={{
                            fontWeight: 700,
                            fontSize: "16px",
                            lineHeight: "28px",
                            letterSpacing: "-0.3%",
                            color: "#f3f3f3",
                          }}
                        >
                          건
                        </PretendardText>
                      </div>
                    </div>
                  </div>
                </ChartContainer>

                {/* 상품별 - 차트 데이터 */}
                <ChartContainer>
                  <ChartHeader
                    style={{
                      height: 88,
                      justifyContent: "space-between",
                    }}
                  >
                    <ChartHeaderText>차트 데이터</ChartHeaderText>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 20,
                      }}
                    >
                      <SearchBar
                        style={{
                          border: "1px solid rgba(255, 255, 255, 0.12)",
                        }}
                        placeholder={
                          selectedSort === "상품별"
                            ? "상품명을 검색해보세요"
                            : "카테고리명을 검색해보세요"
                        }
                        value={keyword}
                        onChange={(e) => {
                          setKeyword(e.target.value);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            if (keyword === "") {
                              navigate(route.statistics_sales, {
                                replace: true,
                              });
                            } else {
                              navigate(
                                `${route.statistics_sales}?page=1&keyword=${keyword}`,
                                {
                                  replace: true,
                                }
                              );
                            }
                          }
                        }}
                        onClick={() => {
                          if (keyword === "") {
                            navigate(route.statistics_sales, {
                              replace: true,
                            });
                          } else {
                            navigate(
                              `${route.statistics_sales}?page=1&keyword=${keyword}`,
                              {
                                replace: true,
                              }
                            );
                          }
                        }}
                      />
                      <SelectBox
                        isMiddle={true}
                        selectedValue={selectedSort}
                        isOpen={sortListBoxOpen}
                        wrapperHandler={() => {
                          setSortListBoxOpen(!sortListBoxOpen);
                        }}
                        itemList={sortList}
                        selectedValueSetterFunc={(value) => {
                          setSelectedSort(value);
                          setSortListBoxOpen(false);
                        }}
                      />
                    </div>
                  </ChartHeader>
                  <ChartGraphWrapper>
                    <div
                      style={{
                        width: "fit-content",
                        height: 23,
                        display: "flex",
                        alignItems: "center",
                        gap: 20,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            backgroundColor: "#38b5a6",
                            borderRadius: "50%",
                          }}
                        />
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "22.75px",
                          }}
                        >
                          판매 금액
                        </PretendardText>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            backgroundColor: "#67c46b",
                            borderRadius: "50%",
                          }}
                        />
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "22.75px",
                          }}
                        >
                          취소 금액
                        </PretendardText>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <span
                          style={{
                            width: 16,
                            height: 16,
                            backgroundColor: "#ffdf34",
                            borderRadius: "50%",
                          }}
                        />
                        <PretendardText
                          style={{
                            color: "#aaa",
                            fontSize: "14px",
                            fontWeight: 600,
                            lineHeight: "22.75px",
                          }}
                        >
                          취소율
                        </PretendardText>
                      </div>
                    </div>
                  </ChartGraphWrapper>
                  {/* 애니메이션 초기화를 위해 조건부 렌더링으로 진행 (dataList 조건으로 다르게 데이터는 방법은 애니메이션 초기화 안 됨) */}
                  {tab.product && selectedSort === "상품별" && (
                    <ProductChart dataList={productDataList} />
                  )}

                  {tab.product && selectedSort === "카테고리별" && (
                    <ProductChart dataList={categoryDataList} />
                  )}

                  {/* 상품별 - 테이블 영역 */}
                  <ChartHeaderText
                    style={{
                      alignSelf: "flex-start",
                      minHeight: 28,
                      margin: "0px 0px 12px 60px",
                    }}
                  >
                    {selectedStartDate !== "" &&
                      selectedStartDate !== selectedEndDate &&
                      `${moment(selectedStartDate).format(
                        "YYYY-MM-DD"
                      )} (${moment(selectedStartDate)
                        .local()
                        .format("ddd")}) → ${moment(selectedEndDate).format(
                        "YYYY-MM-DD"
                      )} (${moment(selectedEndDate).local().format("ddd")})`}
                    {selectedStartDate !== "" &&
                      selectedStartDate === selectedEndDate &&
                      `${moment(selectedStartDate).format(
                        "YYYY-MM-DD"
                      )} (${moment(selectedStartDate).local().format("ddd")})`}
                  </ChartHeaderText>
                  <table
                    style={{
                      width: "924px",
                      borderSpacing: 0,
                      borderCollapse: "collapse",
                      marginBottom: 40,
                    }}
                  >
                    <colgroup>
                      {/* 합계: 924px */}
                      {/* 순 판매금액 */}
                      <col width="128px" />
                      {/* 평균 상품 금액 */}
                      <col width="142px" />
                      {/* 판매개수 */}
                      <col width="123px" />
                      {/* 취소개수 */}
                      <col width="115px" />
                      {/* 취소율 */}
                      <col width="111px" />
                      {/* 판매금액 */}
                      <col width="148px" />
                      {/* 취소금액 */}
                      <col width="157px" />
                    </colgroup>
                    <thead>
                      <tr
                        style={{
                          height: 41,
                          backgroundColor: "#313233",
                          // borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                        }}
                      >
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            순 판매금액
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            평균 상품 금액
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            판매개수
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            취소개수
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            취소율
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            판매금액
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                              paddingRight: 38,
                            }}
                          >
                            취소금액
                          </TableText>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        style={{
                          height: 40,
                          // borderBottom:
                          //   "0.5px solid rgba(255, 255, 255, 0.12)",
                        }}
                      >
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(
                              productTableObj.totalRealRevenue
                            )}
                            원
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(
                              productTableObj.totalAvgPrice
                            )}
                            원
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(
                              productTableObj.totalSalesCount
                            )}
                            건
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(
                              productTableObj.totalCancelCount
                            )}
                            건
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {productTableObj.totalCancelRate}%
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                            }}
                          >
                            {formatNumberWithCommas(
                              productTableObj.totalRevenue
                            )}
                            원
                          </TableText>
                        </td>
                        <td>
                          <TableText
                            style={{
                              textAlign: "right",
                              paddingRight: 38,
                            }}
                          >
                            {formatNumberWithCommas(
                              productTableObj.totalCancelRevenue
                            )}
                            원
                          </TableText>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ChartContainer>
              </>
            )}

            {/* ********** 환경별 ********** */}
            {tab.environment && (
              <>
                {/* 환경별 - 요약 */}
                <ChartContainer
                  style={{
                    height: "fit-content",
                    minHeight: 107,
                  }}
                >
                  <ChartHeader>
                    <ChartHeaderText>요약</ChartHeaderText>
                  </ChartHeader>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* 환경별 - 요약 - 결제수단별 */}
                    <div
                      style={{
                        width: "100%",
                        height: 32,
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: 30,
                        backgroundColor: "#313233",
                        borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 600,
                          fontSize: "13px",
                          lineHeight: "22.75px",
                          color: "#aaa",
                        }}
                      >
                        결제수단별
                      </PretendardText>
                    </div>
                    {/* 환경별 - 요약 - 결제수단별 - 각 영역 */}
                    <div
                      style={{
                        width: "100%",
                        minHeight: 107,
                        display: "flex",
                        // alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {/* 환경별 - 요약 - 결제수단별 - 각 영역 - 체크·신용카드*/}
                      <div
                        style={{
                          width: 261,
                          borderRight: "0.5px solid rgba(255, 255, 255, 0.12)",
                          height: "100%",
                          padding: "20px 30px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            lineHeight: "22.75px",
                            color: "#aaa",
                          }}
                        >
                          체크·신용카드
                        </PretendardText>
                        <div
                          style={{
                            width: "100%",
                            flexWrap: "wrap",
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "30px",
                              lineHeight: "41.5px",
                              color: "#f3f3f3",
                              marginRight: 4,
                            }}
                          >
                            {formatNumberWithCommas(
                              methodDataObj.creditCard?.realpay || 0
                            )}
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#f3f3f3",
                            }}
                          >
                            원
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#009bde",
                            }}
                          >
                            ({methodDataObj.creditCard?.percent || 0}%)
                          </PretendardText>
                        </div>
                      </div>
                      {/* 환경별 - 요약 - 결제수단별 - 각 영역 -카카오페이*/}
                      <div
                        style={{
                          width: 261,
                          borderRight: "0.5px solid rgba(255, 255, 255, 0.12)",
                          height: "100%",
                          padding: "20px 30px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            lineHeight: "22.75px",
                            color: "#aaa",
                          }}
                        >
                          카카오페이
                        </PretendardText>
                        <div
                          style={{
                            width: "100%",
                            flexWrap: "wrap",
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "30px",
                              lineHeight: "41.5px",
                              color: "#f3f3f3",
                              marginRight: 4,
                            }}
                          >
                            {formatNumberWithCommas(
                              methodDataObj.kakaoPay?.realpay || 0
                            )}
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#f3f3f3",
                            }}
                          >
                            원
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#009bde",
                            }}
                          >
                            ({methodDataObj.kakaoPay?.percent || 0}%)
                          </PretendardText>
                        </div>
                      </div>

                      {/* 환경별 - 요약 - 결제수단별 - 각 영역 - 토스페이*/}
                      <div
                        style={{
                          width: 261,
                          borderRight: "0.5px solid rgba(255, 255, 255, 0.12)",
                          height: "100%",
                          padding: "20px 30px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            lineHeight: "22.75px",
                            color: "#aaa",
                          }}
                        >
                          토스페이
                        </PretendardText>
                        <div
                          style={{
                            width: "100%",
                            flexWrap: "wrap",
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "30px",
                              lineHeight: "41.5px",
                              color: "#f3f3f3",
                              marginRight: 4,
                            }}
                          >
                            {formatNumberWithCommas(
                              methodDataObj.toss?.realpay || 0
                            )}
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#f3f3f3",
                            }}
                          >
                            원
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#009bde",
                            }}
                          >
                            ({methodDataObj.toss?.percent || 0}%)
                          </PretendardText>
                        </div>
                      </div>

                      {/* 환경별 - 요약 - 결제수단별 - 각 영역 - 네이버페이*/}
                      <div
                        style={{
                          width: 261,
                          borderRight: "0.5px solid rgba(255, 255, 255, 0.12)",
                          height: "100%",
                          padding: "20px 30px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            lineHeight: "22.75px",
                            color: "#aaa",
                          }}
                        >
                          네이버페이
                        </PretendardText>
                        <div
                          style={{
                            width: "100%",
                            flexWrap: "wrap",
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "30px",
                              lineHeight: "41.5px",
                              color: "#f3f3f3",
                              marginRight: 4,
                            }}
                          >
                            {formatNumberWithCommas(
                              methodDataObj.naverPay?.realpay || 0
                            )}
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#f3f3f3",
                            }}
                          >
                            원
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#009bde",
                            }}
                          >
                            ({methodDataObj.naverPay?.percent || 0}%)
                          </PretendardText>
                        </div>
                      </div>
                    </div>

                    {/* 환경별 - 요약 - 기기별 */}
                    <div
                      style={{
                        width: "100%",
                        height: 32,
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: 30,
                        backgroundColor: "#313233",
                        borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                        borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                      }}
                    >
                      <PretendardText
                        style={{
                          fontWeight: 600,
                          fontSize: "13px",
                          lineHeight: "22.75px",
                          color: "#aaa",
                        }}
                      >
                        기기별
                      </PretendardText>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        minHeight: 107,
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {/* 환경별 - 요약 - 기기별 - 각 영역 - PC*/}
                      <div
                        style={{
                          width: 544,
                          borderRight: "0.5px solid rgba(255, 255, 255, 0.12)",
                          height: "100%",
                          padding: "20px 30px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            lineHeight: "22.75px",
                            color: "#aaa",
                          }}
                        >
                          PC
                        </PretendardText>
                        <div
                          style={{
                            width: "100%",
                            flexWrap: "wrap",
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "30px",
                              lineHeight: "41.5px",
                              color: "#f3f3f3",
                              marginRight: 4,
                            }}
                          >
                            {formatNumberWithCommas(
                              deviceDataObj.pc?.realpay || 0
                            )}
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#f3f3f3",
                            }}
                          >
                            원
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#009bde",
                            }}
                          >
                            ({deviceDataObj.pc?.percent || 0}%)
                          </PretendardText>
                        </div>
                      </div>

                      {/* 환경별 - 요약 - 기기별 - 각 영역 - 모바일*/}
                      <div
                        style={{
                          width: 544,
                          borderRight: "0.5px solid rgba(255, 255, 255, 0.12)",
                          height: "100%",
                          padding: "20px 30px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <PretendardText
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            lineHeight: "22.75px",
                            color: "#aaa",
                          }}
                        >
                          Mobile
                        </PretendardText>
                        <div
                          style={{
                            width: "100%",
                            flexWrap: "wrap",
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "30px",
                              lineHeight: "41.5px",
                              color: "#f3f3f3",
                              marginRight: 4,
                            }}
                          >
                            {formatNumberWithCommas(
                              deviceDataObj.mo?.realpay || 0
                            )}
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#f3f3f3",
                            }}
                          >
                            원
                          </PretendardText>
                          <PretendardText
                            style={{
                              fontWeight: 700,
                              fontSize: "16px",
                              lineHeight: "28px",
                              letterSpacing: "-0.3%",
                              color: "#009bde",
                            }}
                          >
                            ({deviceDataObj.mobile?.percent || 0}%)
                          </PretendardText>
                        </div>
                      </div>
                    </div>
                  </div>
                </ChartContainer>

                {/* 환경별 - 차트 데이터 */}
                <ChartContainer>
                  <ChartHeader
                    style={{
                      height: 88,
                      justifyContent: "space-between",
                    }}
                  >
                    <ChartHeaderText>차트 데이터</ChartHeaderText>
                    <SelectBox
                      isMiddle={true}
                      selectedValue={selectedEnvSort}
                      isOpen={envSortListBoxOpen}
                      wrapperHandler={() => {
                        setEnvSortListBoxOpen(!envSortListBoxOpen);
                      }}
                      itemList={envSortList}
                      selectedValueSetterFunc={(value) => {
                        setSelectedEnvSort(value);
                        setEnvSortListBoxOpen(false);
                      }}
                    />
                  </ChartHeader>
                  {/* 애니메이션 초기화를 위해 조건부 렌더링으로 진행 (dataList 조건으로 다르게 데이터는 방법은 애니메이션 초기화 안 됨) */}
                  {tab.environment && selectedEnvSort === "기기별" && (
                    <EnvironmentChart dataList={deviceDataList} />
                  )}

                  {tab.environment && selectedEnvSort === "결제수단별" && (
                    <EnvironmentChart dataList={methodDataList} />
                  )}

                  {/* 상품별 - 테이블 영역 */}
                  <ChartHeaderText
                    style={{
                      alignSelf: "flex-start",
                      margin: "0px 0px 12px 60px",
                    }}
                  >
                    평균
                  </ChartHeaderText>
                  <table
                    style={{
                      width: "924px",
                      borderSpacing: 0,
                      borderCollapse: "collapse",
                      marginBottom: 40,
                    }}
                  >
                    <colgroup>
                      {/* 합계: 924px */}
                      {/* 기기 */}
                      <col width="78px" />
                      {/* 매출 */}
                      <col width="169px" />
                      {/* 구매 건수 */}
                      <col width="112px" />
                      {/* 상품금액 */}
                      <col width="138px" />
                      {/* 할인금액 */}
                      <col width="136px" />
                      {/* 결제금액 */}
                      <col width="138px" />
                      {/* 환불금액 */}
                      <col width="153px" />
                    </colgroup>
                    <thead>
                      <tr
                        style={{
                          height: 41,
                          backgroundColor: "#313233",
                        }}
                      >
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              paddingLeft: 35,
                            }}
                          >
                            기기
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            매출
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            구매 건수
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            상품금액
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            할인금액
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                            }}
                          >
                            결제금액
                          </TableText>
                        </th>
                        <th>
                          <TableText
                            style={{
                              fontWeight: "600",
                              lineHeight: "22.75px",
                              textAlign: "right",
                              paddingRight: 35,
                            }}
                          >
                            환불금액
                          </TableText>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(selectedEnvSort === "기기별"
                        ? deviceDataList
                        : methodDataList
                      ).map((item, index) => {
                        return (
                          <>
                            <tr
                              key={index}
                              style={{
                                height: 40,
                              }}
                            >
                              <td>
                                <TableText
                                  style={{
                                    paddingLeft: 35,
                                  }}
                                >
                                  {selectedEnvSort === "기기별"
                                    ? item.payenv
                                    : item.paymethod}
                                </TableText>
                              </td>
                              <td>
                                <TableText
                                  style={{
                                    textAlign: "right",
                                  }}
                                >
                                  {formatNumberWithCommas(
                                    (item?.realpay || 0) -
                                      (item?.refundamount || 0)
                                  )}
                                  원
                                </TableText>
                              </td>
                              <td>
                                <TableText
                                  style={{
                                    textAlign: "right",
                                  }}
                                >
                                  {formatNumberWithCommas(
                                    item?.salescount || 0
                                  )}
                                  건
                                </TableText>
                              </td>
                              <td>
                                <TableText
                                  style={{
                                    textAlign: "right",
                                  }}
                                >
                                  {formatNumberWithCommas(item?.totalpay || 0)}
                                  원
                                </TableText>
                              </td>
                              <td>
                                <TableText
                                  style={{
                                    textAlign: "right",
                                  }}
                                >
                                  {formatNumberWithCommas(
                                    (item?.couponpay || 0) +
                                      (item?.pointpay || 0)
                                  )}
                                  원
                                </TableText>
                              </td>
                              <td>
                                <TableText
                                  style={{
                                    textAlign: "right",
                                  }}
                                >
                                  {formatNumberWithCommas(item?.realpay || 0)}원
                                </TableText>
                              </td>
                              <td>
                                <TableText
                                  style={{
                                    textAlign: "right",
                                    paddingRight: 35,
                                  }}
                                >
                                  {formatNumberWithCommas(
                                    item?.refundamount || 0
                                  )}
                                  원
                                </TableText>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </ChartContainer>
              </>
            )}
          </TabContentContainer>
        </DetailPageLayout>
      </MainLayout>

      {modalIsOpen && (
        <Modal
          type="alert"
          title={modalTitle}
          text={modalText}
          setModalOpen={setModalIsOpen}
          onClick={() => {
            setModalIsOpen(false);
          }}
        />
      )}
    </>
  );
};

export default StatisticsSales;

const TabWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
`;

const Tab = styled.div.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 19px 34.5px;
  border-bottom: ${(props) => (props.isActive ? "2px solid #27beff" : "none")};
  cursor: pointer;
`;

const TabText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: -0.3%;
  color: ${(props) =>
    props.isActive ? "#27beff" : "rgba(181, 181, 181, 0.5)"};
`;

const TabContentContainer = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const TabContentHeader = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const DateTypeBtnWrapper = styled.div.attrs((props) => {})`
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DateTypeBtn = styled(PretendardText).attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 3px 10px;
  border-radius: 4px;
  border: ${(props) =>
    props.isActive
      ? "1px solid rgba(0, 155, 222, 1)"
      : "1px solid rgba(255, 255, 255, 0.12)"};
  background-color: #272829;
  font-weight: 500;
  font-size: 14px;
  line-height: 22.75px;
  text-align: center;
  color: ${(props) => (props.isActive ? "#009bde" : "#aaa")};
  cursor: pointer;
`;

const ChartContainer = styled.div.attrs((props) => {})`
  width: 1044px;
  height: fit-content;
  min-height: 439px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  border-radius: 10px;
  background: #272829;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
`;

const ChartHeader = styled.div.attrs((props) => {})`
  width: 100%;
  height: 59px;
  display: flex;
  align-items: center;
  padding: 0px 30px;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.12);
`;

const ChartGraphWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  padding: 24px 30px;
`;

const ChartHeaderText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;
